import { render, staticRenderFns } from "./truck.vue?vue&type=template&id=14587bb0&scoped=true&"
import script from "./truck.vue?vue&type=script&lang=js&"
export * from "./truck.vue?vue&type=script&lang=js&"
import style0 from "./truck.vue?vue&type=style&index=0&id=14587bb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14587bb0",
  null
  
)

export default component.exports